module.exports = __webpack_public_path__ + "img/calendar-fold-white.bf469c8a.svg";